import React from "react";
import CardClass from "../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import MainContext from "../../../Context/MainContext/MainContext";
import MUIAutocomplete from "@mui/material/Autocomplete";

export default class CardPatientCreateGeneral extends CardClass {

    static contextType = MainContext; // For legacy class components

    /**
     * Render the content of the card.
     */
    renderContent() {
        const getGenderOptions = () => {
            return [
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
                { value: "Other", label: "Other" }
            ];
        }

        const getStateListOptions = () => {
            return [
                { value: "AL", label: "AL" },
                { value: "AK", label: "AK" },
                { value: "AZ", label: "AZ" },
                { value: "AR", label: "AR" },
                { value: "CA", label: "CA" },
                { value: "CO", label: "CO" },
                { value: "CT", label: "CT" },
                { value: "DE", label: "DE" },
                { value: "FL", label: "FL" },
                { value: "GA", label: "GA" },
                { value: "HI", label: "HI" },
                { value: "ID", label: "ID" },
                { value: "IL", label: "IL" },
                { value: "IN", label: "IN" },
                { value: "IA", label: "IA" },
                { value: "KS", label: "KS" },
                { value: "KY", label: "KY" },
                { value: "LA", label: "LA" },
                { value: "ME", label: "ME" },
                { value: "MD", label: "MD" },
                { value: "MA", label: "MA" },
                { value: "MI", label: "MI" },
                { value: "MN", label: "MN" },
                { value: "MS", label: "MS" },
                { value: "MO", label: "MO" },
                { value: "MT", label: "MT" },
                { value: "NE", label: "NE" },
                { value: "NV", label: "NV" },
                { value: "NH", label: "NH" },
                { value: "NJ", label: "NJ" },
                { value: "NM", label: "NM" },
                { value: "NY", label: "NY" },
                { value: "NC", label: "NC" },
                { value: "ND", label: "ND" },
                { value: "OH", label: "OH" },
                { value: "OK", label: "OK" },
                { value: "OR", label: "OR" },
                { value: "PA", label: "PA" },
                { value: "RI", label: "RI" },
                { value: "SC", label: "SC" },
                { value: "SD", label: "SD" },
                { value: "TN", label: "TN" },
                { value: "TX", label: "TX" },
                { value: "UT", label: "UT" },
                { value: "VT", label: "VT" },
                { value: "VA", label: "VA" },
                { value: "WA", label: "WA" },
                { value: "WV", label: "WV" },
                { value: "WI", label: "WI" },
                { value: "WY", label: "WY" },
                { value: "DC", label: "DC" }
            ];
        }

        return (
            <MUIGrid container spacing={2}>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.patient?.firstName ?? ""}
                        autoFocus={true}
                        size="small"
                        label="First Name"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ firstName: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ firstName: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.firstName ? true : false}
                        helperText={this.props.validationIssues.firstName ? this.props.validationIssues.firstName : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={4}>
                    <MUITextField
                        value={this.props.patient?.lastName ?? ""}
                        size="small"
                        label="Last Name"
                        variant="standard"
                        fullWidth={true}
                        inputProps={{
                            maxLength: 255,
                        }}
                        InputLabelProps={{ shrink: true }}
                        onBlur={(e) => this.props.onChange({ lastName: e.target.value.trim() })}
                        onChange={(e) => this.props.onChange({ lastName: e.target.value })}
                        required={true}
                        error={this.props.validationIssues.lastName ? true : false}
                        helperText={this.props.validationIssues.lastName ? this.props.validationIssues.lastName : ""}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={2}>
                    <MUIDatePicker
                        label="DOB"
                        value={
                            this.props.patient?.dateOfBirth
                                ? moment(this.props.patient.dateOfBirth, 'M/D/YYYY').isValid()
                                    ? moment(this.props.patient.dateOfBirth, 'M/D/YYYY')
                                    : null
                                : null
                        }
                        slotProps={{
                            textField: {
                                fullWidth: true,
                                size: "small",
                                variant: 'standard',
                                required: true,
                                error: this.props.validationIssues.dateOfBirth ? true : false,
                                helperText: this.props.validationIssues.dateOfBirth ? this.props.validationIssues.dateOfBirth : "",
                                InputLabelProps: {
                                    shrink: true
                                },
                            },
                        }}
                        onChange={(value) => this.props.onChange({ dateOfBirth: moment(value).format('M/D/YYYY') })}
                        views={['year', 'month', 'day']}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={1}>
                    <MUIAutocomplete
                        options={getGenderOptions()}
                        value={getGenderOptions().find(option => option.value === this.props.patient?.gender) || null}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        getOptionLabel={(option) => option?.label || ''}
                        disableClearable
                        onChange={(e, newValue) => this.props.onChange({ gender: newValue?.value || null })}
                        renderInput={(params) => (
                            <MUITextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                variant="standard"
                                label="Sex"
                                fullWidth
                                required={true}
                                error={this.props.validationIssues.gender ? true : false}
                                helperText={this.props.validationIssues.gender ? this.props.validationIssues.gender : ""}
                            />
                        )}
                    />
                </MUIGrid>
                <MUIGrid item xs={12} sm={6} md={1}>
                    <MUIAutocomplete
                        options={getStateListOptions()}
                        value={getStateListOptions().find(option => option.value === this.props.patient?.state) || null}
                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                        getOptionLabel={(option) => option?.label || ''}
                        onChange={(e, newValue) => this.props.onChange({ state: newValue?.value || null })}
                        renderInput={(params) => (
                            <MUITextField
                                {...params}
                                InputLabelProps={{ shrink: true }}
                                size="small"
                                variant="standard"
                                label="State"
                                fullWidth
                                required={true}
                                error={this.props.validationIssues.state ? true : false}
                                helperText={this.props.validationIssues.state ? this.props.validationIssues.state : ""}
                            />
                        )}
                    />
                </MUIGrid>
            </MUIGrid >
        );
    }

    /**
     * @returns {string} The title of the card.
     */
    getTitle() {
        return "General";
    }
}